@if (showHowTo()) {
  <button
    type="button"
    nz-button
    nzType="default"
    (click)="onOpen()"
    nz-tooltip
    nzTooltipTitle="How-To: related articles for this page"
    nzTooltipPlacement="bottom"
    class="page-how-to-btn"
  >
    <span nz-icon nzType="read" nzTheme="outline"></span>
    <span class="ml-xs hidden-xs">How To</span>
  </button>
}
